import m from "mithril";
import Auth from "../../../shared/auth";
import i18n from "../../../shared/i18n/i18n";
import Requester from "../../../shared/request";
import Gateway from "../../../shared/app_settings";
import Toasts from "../../../shared/toasts";
import FormUtilities from "../../../shared/utilities/form_utilities";
import ModalManager from "../../../shared/modal";
import Modal_Confirm_Delete from "../../../shared/components/modal_confirm_delete";
import Component_Autocomplete from "../../../shared/components/component_autocomplete";
import RouterService from "../../../shared/services/router.service";
import { getUnitActiveStatusSlider } from "../unit_status_slider_util";
import TextEditor from "../../../shared/components/component_text_editor";
import TextUtilities from "../../../shared/utilities/text_utilities";
import {loadCourses} from "../unit_courses";

let saving, uploading, deleting, unit, templates, loading, loadFailed;
let onCoursesClick;

function saveUnitDetails() {
    if (FormUtilities.validateFields(".form input")) {
        saving = true;
        Requester.post(Gateway.admin + "units/assessment/" + unit.id, {
            id: unit.id,
            name: unit.name,
            description: unit.description,
            instructions: unit.instructions
        })
            .then(function (result) {
                saving = false;
                Toasts.add("success", i18n.t("saved_changes"), "");
            })
            .catch(function (error) {
                saving = false;
                Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
            });
    }
}

function saveUnitSettings() {
    saving = true;
    Requester.post(Gateway.admin + "units/assessment/" + unit.id + "/settings", {
        assessorIds: unit.assessors.map(x => x.id),
        assessorEmailTemplateId: unit.assessorEmailTemplateId,
        rejectionEmailTemplateId: unit.rejectionEmailTemplateId
    })
        .then(function (result) {
            saving = false;
            // Keep the ids in step with the saved list, so returning to this tab shows it
            unit.assessorIds = unit.assessors.map(x => x.id);
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            saving = false;
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
}

function getTemplates() {
    Requester.get(Gateway.admin + "emails/templates")
        .then(function (result) {
            templates = result.entities;
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
}

function getTemplateName(templateId) {
    if (templateId && templates) {
        for (let i = 0; i < templates.length; i++) {
            if (templates[i].properties.id === templateId) {
                return templates[i].properties.name;
            }
        }
    }

    return "None";
}

function confirmDeleteUnit() {
    ModalManager.open(i18n.t("delete_unit"), [], Modal_Confirm_Delete, { callback: deleteUnit });
}

function deleteUnit() {
    deleting = true;
    Requester.delete(Gateway.admin + "units/assessment/" + unit.id)
        .then(function () {
            RouterService.navigateToUnits();
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            deleting = false;
        });
}

function getAssessorDetails() {
    unit.assessors = [];
    loading = true;
    // Ask for every assessor; the endpoint returns 25 by default
    Requester.get(Gateway.admin + "users?userIds=" + unit.assessorIds.join(',') + "&limit=" + unit.assessorIds.length)
        .then(function (result) {
            for (let i = 0; i < result.entities.length; i++) {
                unit.assessors.push({
                    id: result.entities[i].properties.id,
                    name: result.entities[i].properties.name
                });
            }
        })
        .catch(function (error) {
            // Saving a partial list would remove the assessors that did not load
            loadFailed = true;
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            loading = false;
        });
}

function addAssessor(user) {
    unit.assessors.push({
        id: user.id,
        name: user.firstName + " " + user.lastName
    });
}

function removeAssessor(user) {
    unit.assessors = unit.assessors.filter(function (u) {
        return u.id !== user.id;
    });
}

const Component_Unit_Assessment_Settings = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
        onCoursesClick = vnode.attrs.onCoursesClick;
        loadCourses(unit.id);
        unit.assessors = [];
        loading = false;
        loadFailed = false;

        if (!unit.toAddresses) {
            unit.toAddresses = [];
        }

        if (unit.assessorIds && unit.assessorIds.length > 0) {
            getAssessorDetails();
        }

        getTemplates();
    },
    view: function () {
        return [
            m(".content-box", [
                m("h3", i18n.t("details")),
                m(".form", { class: !Auth.validateRights(["unit_assessment_edit"]) ? "disabled" : "" }, [
                    m(".form-section required", [
                        m(".form-label", i18n.t("name")),
                        m("input[type=text]", {
                            oninput: function () {
                                unit.name = this.value;
                            },
                            value: unit.name
                        })
                    ]),
                    m(".form-section", [
                        m(".form-label", i18n.t("description_not_visible_to_learners")),
                        m("textarea", {
                            oninput: function () {
                                unit.description = this.value;
                            },
                            value: unit.description
                        })
                    ]),
                    m(".form-section required", [
                        m(".form-label", i18n.t("instructions_will_appear_for_learners")),
                        m(TextEditor, {
                            content: encodeURIComponent(unit.instructions || ""),
                            hideHyperlink: true,
                            onchange: function (content) {
                                unit.instructions = content;
                            }
                        }),
                        !TextUtilities.hasVisibleText(unit.instructions) ? m(".text-error.padding", {style: "font-size: 0.75rem;"}, i18n.t("complete_required_fields")) : ""
                    ]),
                    m(".form-buttons", [
                        saving || uploading
                            ? m("button.btn-text no-click", [i18n.t("saving"), m(".loading-dots")])
                            : !!unit.name && TextUtilities.hasVisibleText(unit.instructions)
                                ? m("button", {onclick: saveUnitDetails}, i18n.t("save_details"))
                                : m("button.btn-text no-click", i18n.t("save_details"))
                    ])
                ])
            ]),
            m(".content-box", [
                m("h3", i18n.t("settings")),
                m(".form", { class: !Auth.validateRights(["unit_assessment_edit"]) ? "disabled" : "" }, [
                    m(".form-section", [
                        m(".form-label", i18n.t("assessors")),
                        m(Component_Autocomplete, {
                            endpoint: "users?permissions=unit_assessment_assessor",
                            submitCallback: addAssessor,
                            propertyName: "name"
                        }),
                        unit.assessors
                            ? unit.assessors.map(function (user) {
                                return [
                                    m("div", [
                                        m("button.btn-text", {
                                            onclick: function () {
                                                removeAssessor(user);
                                            }
                                        }, "x"),
                                        user.name
                                    ])
                                ];
                            })
                            : m(".text-gray padding", i18n.t("loading_dots"))
                    ]),
                    m(".form-buttons", [
                        !saving && !uploading
                            ? m("button", { onclick: saveUnitSettings, class: loading || loadFailed ? "disabled" : "", disabled: loading || loadFailed }, i18n.t("save_settings"))
                            : m("button.btn-text no-click", [i18n.t("saving"), m(".loading-dots")])
                    ])
                ])
            ]),
            m(".content-box", [
                m(".form", { class: !Auth.validateRights(["unit_assessment_edit"]) ? "disabled" : "" }, [
                    getUnitActiveStatusSlider(unit, saving, onCoursesClick)
                ])
            ]),
            Auth.validateRights(["unit_assessment_delete"], [
                m(".content-box", [
                    !deleting
                        ? m("button.btn-error", { onclick: confirmDeleteUnit }, i18n.t("delete_unit"))
                        : m("button.btn-text no-click text-error", [i18n.t("deleting"), m(".loading-dots")])
                ])
            ])
        ];
    }
};

export default Component_Unit_Assessment_Settings;
